let businessContextRevision = 0

/**
 * Monotonic ownership id for requests and business-context transactions.
 * Token text alone is insufficient because rollback can produce A -> B -> A.
 */
export function getBusinessContextRevision() {
  return businessContextRevision
}

export function advanceBusinessContextRevision() {
  businessContextRevision += 1
  return businessContextRevision
}

export function resetBusinessContextRevisionForTest() {
  businessContextRevision = 0
}
